import { Injectable } from '@angular/core';
 
 
import { Observable } from 'rxjs';
 
import { HttpClient } from '@angular/common/http';
import { AppSettings } from './app.setting';
import { Stand } from '../entity/stand.model';
import { environment } from 'src/environments/environment';
 


@Injectable({
  providedIn: 'root'
})
export class FloorService {

  private baseUrl: string = environment.restApiERP + 'stand';
  
  constructor(private http: HttpClient ) { }




  get(id: number): Observable<Stand> {
    return this.http.get<Stand>(this.baseUrl + '/' + id);
  }
 /*
  add(stand :Stand): Observable<Stand>{
    //console.log("this.selectedStand namec"+stand.namec);
   return this.http.post<Stand>(`${this.baseUrl}`,stand);
   }
 edit(stand :Stand): Observable<Stand>{
  //console.log("this.selectedStand namec"+stand.namec);
 return this.http.put<Stand>(`${this.baseUrl}/${stand.idStand}`,stand);
 }
 remove(stand :Stand): Observable<Stand>{
  //console.log("this.selectedStand namec"+stand.namec);
 return this.http.delete<Stand>(`${this.baseUrl}/${stand.idStand}` );
 }
  */
  getAllInside(isInside:boolean): Observable<Stand[]> {
    return this.http.get<Stand[]>(this.baseUrl+ '/standinside/' +isInside);
  }
  getAll() : Observable<Stand[]> {
    return this.http.get<Stand[]>(this.baseUrl);
  }
  getContenu(id: number): Observable<Stand> {
    return this.http.get<Stand>(this.baseUrl + '/contenuStand/' + id);
  }

  findAllUpdate( ): Observable<Stand[]> {
    return this.http.get<Stand[]>(this.baseUrl + '/findAllUpdate' );
  }
  private handleError(error) {
    //console.log(error);
  }
}
